<div class='sso-activation'>
   <h2>{{localeTexts?.signupTab?.activateYourAccount}}</h2>
  <div class='sso-activation-info sso-row'>
    <div class='sso-activation-icon' aria-hidden='true' [style.backgroundImage]="'url('+ localeTexts?.signupTab?.activationIcon +')'"></div>

    <div class='sso-activation-details sso-column'>
      <p>{{localeTexts?.signupTab?.emailWithActivationLink}}</p>
      <div *ngIf='email' class='sso-activation-email'>
        <mat-icon>check</mat-icon> 
        <div>{{email}}</div>
      </div>
    </div>
  </div>

  <p class='sso-activation-resend'>
    {{localeTexts?.signupTab?.noEmail}} 
    <a href='#' (click)='clickResendEmail($event)' [ngClass]='{"sso-activation-disabled":resendActivationLink}'>
      {{localeTexts?.signupTab?.resendLink}}
    </a>
  </p>
</div>
